module.exports = __webpack_public_path__ + "media/registry-cover_2400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/registry-cover_2400.jpg
// module id = 30
// module chunks = 0